import { createStore, createHook } from 'react-sweet-state';
import type { Project } from '@atlassian/jira-common-constants/src/project-types';

export type State = {
	isModalOpen: boolean;
	project: Project | null;
};

export type StateActions = {
	getState: () => State;
	setState: (state: State) => void;
};

export const initialState: State = {
	isModalOpen: false,
	project: null,
};

export const actions = {
	openModal:
		() =>
		({ getState, setState }: StateActions) => {
			setState({
				...getState(),
				isModalOpen: true,
			});
		},
	closeModal:
		() =>
		({ getState, setState }: StateActions) => {
			setState({
				...getState(),
				isModalOpen: false,
			});
		},
	setProject:
		(project: Project | null) =>
		({ getState, setState }: StateActions) => {
			setState({
				...getState(),
				project,
			});
		},
};

export type Actions = typeof actions;

export const store = createStore<State, Actions>({
	name: 'gic.import.issues.x2c.modal',
	initialState,
	actions,
});

export const useX2CModalContext = createHook(store);
